import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { PhoneFormatPipe } from 'src/app/shared/pipes/phone-format.pipe';
import { AuthApiService } from '../../core/api-services/auth-api.service';
import { Profile } from '../../core/data-models/profile.model';

/**
 * Admin Profile Page Component
 * Read-only view of the current admin user's profile information.
 * Fetches data from GET /auth/me (same as settings page).
 */
@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, PhoneFormatPipe],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
  profile: Profile | null = null;
  loading = true;
  errorMessage = '';

  constructor(private authApi: AuthApiService) {}

  async ngOnInit(): Promise<void> {
    await this.loadProfile();
  }

  async loadProfile(): Promise<void> {
    this.loading = true;
    this.errorMessage = '';

    try {
      this.profile = await firstValueFrom(this.authApi.getMe());
    } catch (error: any) {
      console.error('Load profile error:', error);
      this.errorMessage = 'Failed to load profile information';
    } finally {
      this.loading = false;
    }
  }

  formatDate(date: string | null | undefined): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  /** `/auth/me` does not say which 2FA method is set up, only whether 2FA is on. */
  get2FAMethodLabel(): string {
    return this.profile?.is2FAEnabled ? 'Enabled' : 'Not enabled';
  }
}
